export default function (/**@type {ApisauceInstance} */ api) {
  const getSettings = (paging) => api.get("Setting", paging);
  const getSettingWithId = (id) => api.get(`Setting/${id}`);
  const editSetting = ({ payload, id }) => api.put(`Setting/${id}`, payload);
  const editAllSettings = (payload) =>
    api.put(`Setting/edit-all-setting`, payload);

  return {
    settings: {
      getSettings,
      getSettingWithId,
      editSetting,
      editAllSettings,
    },
  };
}
